import { g as getCollectionSchema } from "../../../../../../../../../chunks/schema.js";
import { g as getMongo } from "../../../../../../../../../chunks/mongo.js";
const load = async ({ params }) => {
  const mongo = await getMongo();
  const client = mongo.getClient(params.server);
  try {
    const schemaInfo = await getCollectionSchema(client, params.database, params.collection);
    return {
      schemaInfo
    };
  } catch {
    return {
      schemaInfo: {
        hasSchema: false,
        validator: null,
        validationLevel: null,
        validationAction: null
      }
    };
  }
};
export {
  load
};
